import LeftImage from "../../Images/(services-offered)-research.webp";
import BackgroundImage from "../../Images/research-bg.webp";
import Service1 from "../../Images/service1rnd.webp";
import Service2 from "../../Images/service2-rnd.webp";
import Service3 from "../../Images/service3-rnd.webp";
import Choose1 from "../../Images/choose1-rnd.png";
import Choose2 from "../../Images/choose2-rnd.png";
import Choose3 from "../../Images/choose3-rnd.png";
import Choose4 from "../../Images/choose4-rnd.png";

const RnDServicesSection = () => {
  return (
    <section className="relative w-full text-gray-800 py-0 md:py-16">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `linear-gradient(rgba(201, 156, 72, 0.8), rgba(201, 156, 72, 0.8)), url(${BackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: -1,
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-0">
        {" "}
        <div
          className="flex flex-col lg:flex-row items-start gap-12"
          data-aos="fade-up"
        >
          {/* ✅ Left Image - flush to the left */}
          <div className="w-full lg:w-1/2">
            <img
              src={LeftImage}
              alt="Left Pyramid Visual"
              className="w-full h-auto object-cover m-0"
              style={{ marginLeft: 0 }}
            />
          </div>

          {/* ✅ Services Offered - transparent background */}
          <div className="w-full lg:w-1/2 bg-transparent p-10">
            <h2 className="text-3xl font-bold mb-8 text-white">
              Services Offered
            </h2>

            <div className="space-y-8" data-aos="fade-up">
              <div className="flex items-start gap-4 pb-3 border-b-[1px] border-[#FFFFFF33]">
                <img src={Service1} alt="Service 1" className="w-12 h-12" />
                <div>
                  <h3 className="text-lg font-semibold text-white">
                    Facilitation of R&D operations in Saudi Arabia
                  </h3>
                  <p className="text-sm text-white/90">
                    We help set up and grow R&D projects by connecting you with
                    key local partners and resources.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-3 border-b-[1px] border-[#FFFFFF33]">
                <img src={Service2} alt="Service 2" className="w-12 h-12" />
                <div>
                  <h3 className="text-lg font-semibold text-white">
                    Assistance with funding and local partnerships
                  </h3>
                  <p className="text-sm text-white/90">
                    We connect you with funding sources and trusted local
                    partners to ensure smooth market entry.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-3 border-b-[1px] border-[#FFFFFF33]">
                <img src={Service3} alt="Service 3" className="w-12 h-12" />
                <div>
                  <h3 className="text-lg font-semibold text-white">
                    Advisory on compliance and innovation opportunities
                  </h3>
                  <p className="text-sm text-white/90">
                    Get expert advice on local regulations and explore
                    innovation-driven business opportunities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ✅ Why Choose Us Section */}
        <div
          className="mt-12 md:mt-24 pb-6 md:pb-0 text-center"
          data-aos="fade-up"
        >
          <h2 className="text-3xl font-bold text-black mb-4">Why Choose Us</h2>
          <p className="text-sm text-black/90 mb-12 max-w-2xl mx-auto">
            We specialize in connecting global investors with high-potential
            opportunities in Saudi Arabia. From local partnerships to regulatory
            support, we offer end-to-end guidance to ensure your investment
            journey is seamless, strategic, and successful.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            <div className="px-4 md:px-2">
              <img
                src={Choose1}
                alt="Choose 1"
                className="w-[50px] h-[50px] mx-auto mb-3"
              />
              <h4 className="font-semibold text-lg mb-1 text-black">
                Find your future home
              </h4>
              <p className="text-sm text-black/80">
                We help you find a new home by offering real estate solutions.
              </p>
            </div>

            <div className="px-4 md:px-2">
              <img
                src={Choose2}
                alt="Choose 2"
                className="w-[50px] h-[50px] mx-auto mb-3"
              />
              <h4 className="font-semibold text-lg mb-1 text-black">
                Experienced agents
              </h4>
              <p className="text-sm text-black/80">
                Find an experienced agent who knows your market best.
              </p>
            </div>

            <div className=" px-4 md:px-2">
              <img
                src={Choose3}
                alt="Choose 3"
                className="w-[50px] h-[50px] mx-auto mb-3"
              />
              <h4 className="font-semibold text-lg mb-1 text-black">
                Buy or rent homes
              </h4>
              <p className="text-sm text-black/80">
                Millions of houses and apartments in your favorite cities.
              </p>
            </div>

            <div className="px-4 md:px-2">
              <img
                src={Choose4}
                alt="Choose 4"
                className="w-[50px] h-[50px] mx-auto mb-3"
              />
              <h4 className="font-semibold text-lg mb-1 text-black">
                List your own property
              </h4>
              <p className="text-sm text-black/80">
                Submit your property for sale or rent and reach thousands.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RnDServicesSection;
